export const GET_CONTENT_IMPRESSION = 'GET_CONTENT_IMPRESSION'
export const SET_CONTENT_IMPRESSION_DATA = 'SET_CONTENT_IMPRESSION_DATA'
export const SET_CONTENT_IMPRESSION_ERROR = 'SET_CONTENT_IMPRESSION_ERROR'
export const SET_CONTENT_IMPRESSION_PROCESSING = 'SET_CONTENT_IMPRESSION_PROCESSING'

export function getContentImpression () {
  return {
    type: GET_CONTENT_IMPRESSION,
  }
}

export function setContentImpressionData ({ data, processing = false } = {}) {
  return {
    type: SET_CONTENT_IMPRESSION_DATA,
    payload: { data, processing },
  }
}

export function setContentImpressionError ({ error, processing = false } = {}) {
  return {
    type: SET_CONTENT_IMPRESSION_ERROR,
    payload: { error, processing },
  }
}

export function setContentImpressionProcessing ({ processing = true } = {}) {
  return {
    type: SET_CONTENT_IMPRESSION_PROCESSING,
    payload: { processing },
  }
}
